// extracted by mini-css-extract-plugin
export default {"appsItemHover":"AppSwitcher_appsItemHover__6+SDr"};